var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5h15.75v10.5H2V5z",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000064",
    strokeWidth: 1.5,
    d: "M2 9.25h15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M7.75 2.75v4.5M11.75 2.75v4.5"
  })));
}
export default SvgIconDate;